import { createAction, props } from '@ngrx/store';
import { LoginResponse, UserDataResult } from 'angular-auth-oidc-client';
import { Subscription } from '@emi/shared/models';

export const checkAuth = createAction('[Auth] - Attempt: Authenticaton');
export const checkAuthComplete = createAction(
  '[Auth] - Complete: Authenticated',
  props<{ loginResponse: LoginResponse }>()
);

export const login = createAction('[Auth] - Attempt: Log In');
export const loginComplete = createAction(
  '[Auth] - Complete: Log In',
  props<{
    subscription: Subscription; 
    subscriptions: Subscription[];
    userData: UserDataResult;
    loginResponse: LoginResponse;
    subscriberJwt: string;
  }>()
);

export const logout = createAction('[Auth] - Attempt: Log Out');
export const logoutComplete = createAction('[Auth] - Complete: Log Out');

export const updateAccessToken = createAction('[Auth] - Update Access Token');
export const updateAccessTokenComplete = createAction(
  '[Auth] - Complete: Access Token Update',
  props<{ accessToken: string }>()
);
